// PowerSync — ai_scenarios / ai_skills (user + builtin streams).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalAiScenario {
	id: string;
	user_id: string | null;
	title: string;
	prompt: string;
	name: string | null;
	description: string | null;
	system_prompt: string | null;
	locale: string;
	is_active: number | null;
	is_builtin: number | null;
	created_at: string;
	updated_at: string;
}

export interface LocalAiSkill {
	id: string;
	user_id: string | null;
	label: string;
	instruction: string;
	name: string | null;
	description: string | null;
	locale: string;
	is_builtin: number | null;
	created_at: string;
	updated_at: string;
}

/** Пользовательские + builtin сценарии (оба stream'а уже в SQLite). */
export function useTutorScenariosQuery(userId: string | undefined, locale?: string) {
	const hasLocale = Boolean(locale);
	return usePowerSyncQuery<LocalAiScenario>(
		hasLocale
			? `SELECT * FROM ai_scenarios
			     WHERE (user_id = ? OR (user_id IS NULL AND is_builtin = 1))
			       AND locale = ?
			  ORDER BY is_builtin DESC, COALESCE(name, title) ASC`
			: `SELECT * FROM ai_scenarios
			     WHERE user_id = ? OR (user_id IS NULL AND is_builtin = 1)
			  ORDER BY is_builtin DESC, COALESCE(name, title) ASC`,
		hasLocale ? [userId ?? "", locale ?? ""] : [userId ?? ""],
	);
}

export function useTutorSkillsQuery(userId: string | undefined, locale?: string) {
	const hasLocale = Boolean(locale);
	return usePowerSyncQuery<LocalAiSkill>(
		hasLocale
			? `SELECT * FROM ai_skills
			     WHERE (user_id = ? OR (user_id IS NULL AND is_builtin = 1))
			       AND locale = ?
			  ORDER BY is_builtin DESC, COALESCE(name, label) ASC`
			: `SELECT * FROM ai_skills
			     WHERE user_id = ? OR (user_id IS NULL AND is_builtin = 1)
			  ORDER BY is_builtin DESC, COALESCE(name, label) ASC`,
		hasLocale ? [userId ?? "", locale ?? ""] : [userId ?? ""],
	);
}
